import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * Generated class for the RupiahFormatDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[rupiah-format]' // Attribute selector
})
export class RupiahFormatDirective {
  constructor(public ngControl: NgControl) { }

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    this.onInputChange(event, false);
  }

  @HostListener('keydown.backspace', ['$event'])
  keydownBackspace(event) {
    this.onInputChange(event.target.value, true);
  }
  

  onInputChange(event, backspace) {
    let newVal = event.replace(/\D/g, '');
    if (backspace && newVal.length <= 18) {
      newVal = newVal.substring(0, newVal.length - 0);
    }
    if (newVal.length === 0) {
      newVal = '';
    } else if (newVal.length <= 3) {
      newVal = newVal.replace(/^(\d{0,3})/, 'Rp. $1');
    } else if (newVal.length <= 4) {
      newVal = newVal.replace(/^(\d{0,1})(\d{0,3})/, 'Rp. $1.$2');
    } else if (newVal.length <= 5) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,3})/, 'Rp. $1.$2');
    } else if (newVal.length <= 6) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, 'Rp. $1.$2');
    } else if (newVal.length <= 7) {
      newVal = newVal.replace(/^(\d{0,1})(\d{0,3})(\d{0,3})/, 'Rp. $1.$2.$3');
    } else if (newVal.length <= 8) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})/, 'Rp. $1.$2.$3');
    } else if (newVal.length <= 9) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})/, 'Rp. $1.$2.$3');
    } else if (newVal.length <= 10) {
      newVal = newVal.replace(/^(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,3})/, 'Rp. $1.$2.$3.$4');
    } else if (newVal.length <= 11) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,3})/, 'Rp. $1.$2.$3.$4');
    } else if (newVal.length <= 12) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, 'Rp. $1.$2.$3.$4');
    } else if (newVal.length <= 13) {
      newVal = newVal.replace(/^(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, 'Rp. $1.$2.$3.$4.$5');
    } else if (newVal.length <= 14) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, 'Rp. $1.$2.$3.$4.$5');
    } else if (newVal.length <= 15) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, 'Rp. $1.$2.$3.$4.$5');
    } else if (newVal.length <= 16) {
      newVal = newVal.replace(/^(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, 'Rp. $1.$2.$3.$4.$5.$6');
    } else if (newVal.length <= 17) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, 'Rp. $1.$2.$3.$4.$5.$6');
    } else if (newVal.length <= 18) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, 'Rp. $1.$2.$3.$4.$5.$6');
    } else {
        newVal = newVal.substring(0, 18);
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/, 'Rp. $1.$2.$3.$4.$5.$6');
    }
    this.ngControl.valueAccessor.writeValue(newVal);
  }
}



// WEBPACK FOOTER //
// ./src/directives/rupiah-format/rupiah-format.ts